import React, { FC, MutableRefObject, SetStateAction, useImperativeHandle, useState } from 'react';
import { Input, InputProps, Select, SelectProps } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { MobileWrap } from './style';
import { IPOInput, IPOSelect } from '../../styles';
import { AREACODE, AreaEnum, IMobileInfo, IMobileRef } from './mobileInput';

interface PMobileInfoProps {
	mobileRef: MutableRefObject<IMobileRef | undefined>;
	disabled?: boolean;
	defaultArea?: AreaEnum;
	mobileInfo?: IMobileInfo;
	selectProps?: SelectProps<SelectValue>;
	inputProps?: InputProps;
	allowClear?: boolean;
}

export const MobileInput: FC<PMobileInfoProps> = ({
	mobileRef,
	disabled,
	defaultArea,
	mobileInfo,
	selectProps,
	inputProps,
	allowClear = true,
}) => {
	const [areaCode, setAreaCode] = useState<AreaEnum>(
		mobileInfo ? mobileInfo.areaCode : defaultArea ?? AreaEnum.HK,
	); // 区域选择
	const [phoneNum, setPhoneNum] = useState<string>(mobileInfo ? mobileInfo.phoneNum : ''); // 手机号

	useImperativeHandle(mobileRef, () => ({ getValidateRes }));

	const getValidateRes: () => {
		res: boolean;
		mobileInfo: IMobileInfo;
	} = () => {
		const Admins: string[] = ['admin', 'administrator'];

		let codeInfo = AREACODE[areaCode];
		return {
			res: codeInfo.reg.test(phoneNum) || Admins.includes(phoneNum.toLowerCase()),
			mobileInfo: { areaCode, phoneNum },
		};
	};
	return (
		<MobileWrap>
			<Input.Group compact>
				<IPOSelect
					alt-tip={JSON.stringify({ tit: AREACODE[areaCode].tip, time: 2 })}
					disabled={disabled ? disabled : false}
					value={areaCode}
					style={{ width: '150px' }}
					onChange={node => setAreaCode(node as AreaEnum)}
					dropdownMatchSelectWidth={false}
					optionLabelProp="label"
					{...selectProps}>
					{Object.keys(AREACODE).map(item => (
						<Select.Option value={item} label={item} key={item}>
							<span>
								{item} {AREACODE[item as AreaEnum].area}
							</span>
						</Select.Option>
					))}
				</IPOSelect>
				<IPOInput
					disabled={disabled ? disabled : false}
					placeholder="请输入"
					value={phoneNum}
					onChange={(node: { target: { value: SetStateAction<string> } }) =>
						setPhoneNum(node.target.value)
					}
					allowClear={allowClear}
					{...inputProps}
				/>
			</Input.Group>
		</MobileWrap>
	);
};
